import { useParams } from "react-router-dom";

type DefaultParams = { objectId: string; projectId: string; tab: string; sectionId: string; subsectionId: string };

export const useTypedParams = <T extends Record<string, string> = {}>() => {
  return useParams<DefaultParams & T>();
};
